function randomLetter() {
  return (Math.floor(Math.random() * 25) + 10).toString(36)
}

function randomByTimestamp() {
  return new Date().getTime().toString(36)
}

export function uniqueKey() {
  return Array.from({ length: 8 }, () => randomLetter())
    .join("")
    .concat(`_${randomByTimestamp()}`)
}
